export class ClassifiedMcc {
    static fromExistingData(classfd: any): ClassifiedMcc {
        const classified = new ClassifiedMcc();

        if (classfd.activateFrom) classified.activateFrom = classfd.activateFrom;
        if (classfd.activateTo) classified.activateTo = classfd.activateTo;
        if (classfd.approved) classified.approved = classfd.approved;
        if (classfd.id) classified.id = +classfd.id;
        if (classfd.categoryId) classified.categoryId = classfd.categoryId;
        if (classfd.content) classified.content = classfd.content;
        if (classfd.createdAt) classified.createdAt = classfd.createdAt;
        if (classfd.createdByUser) classified.createdBy = classfd.createdByUser.firstname + ' ' + classfd.createdByUser.lastname;
        if (classfd.declined) classified.declined = classfd.declined;
        if (classfd.editedAt) classified.editedAt = classfd.editedAt;
        if (classfd.email) classified.email = classfd.email;
        if (classfd.name) classified.name = classfd.name;
        if (classfd.phone) classified.phone = classfd.phone;
        if (classfd.public) classified.isPublic = classfd.public;
        if (classfd.residentId) classified.residentId = classfd.residentId;
        if (classfd.status) classified.status = classfd.status;
        if (classfd.styleAll) classified.styleAll = classfd.styleAll;
        if (classfd.title) classified.title = classfd.title;
        if (classfd.unitId) classified.suiteId = classfd.unitId;
        if (classfd.userType) classified.userType = classfd.userType;

        return classified;
    }

    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public activateFrom: string = '',
        public activateTo: string = '',
        public approved: boolean = false,
        public categoryId: number = null,
        public content: string = '',
        public createdAt: string = '',
        public createdBy: string = '',
        public declined: boolean = false,
        public editedAt: string = '',
        public email: string = '',
        public name: string = '',
        public phone: string = '',
        public isPublic: boolean = false,
        public status: string = '',
        public styleAll: string = '',
        public title: string = '',
        public userType: string = ''
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ClassifiedMcc.ts